module.exports = __webpack_public_path__ + "static/front/img/instagram1.5c19fb1d.jpg";